// TableRow.js
import React from 'react';

const TableRow = ({ item, columns, onCenter }) => (
    <tr>
        <td className="text-center">
            <button className="btn btn-primary btn-sm text-white" onClick={() => onCenter(item)}>
                <i className="fas fa-map-marker-alt"></i>
            </button>
        </td>
        {columns.map((col) => (
            <td key={col.key} className="d-none d-md-table-cell">
                {item[col.key]}
            </td>
        ))}
    </tr>
);

export default React.memo(TableRow);
